export const buildCVShareUrl = (cvId: string): string =>
  `${window.location.origin}/cv/${cvId}`;
